/**
 * Dotted app versions, shared by the server (X-App-Version check, `minClient`) and the client
 * (does the build I run meet `config.minClient`?).
 *
 * Builds are stamped `<package version>+<base36 build stamp>` (client/vite.config.ts), and a
 * dev build may carry a pre-release tag (`0.0.0-dev`). Both suffixes are ignored: only the
 * dotted numbers decide. A part that is not a number counts as 0.
 */
export function compareVersions(a: string, b: string): number {
  const pa = parts(a);
  const pb = parts(b);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] ?? 0;
    const y = pb[i] ?? 0;
    if (x !== y) return x < y ? -1 : 1;
  }
  return 0;
}

function parts(v: string): number[] {
  const core = v.trim().split(/[-+]/)[0] ?? '';
  return core.split('.').map((p) => Number(p) || 0);
}

/** True when `version` is older than `minClient`. */
export function isBelowMin(version: string, minClient: string): boolean {
  return compareVersions(version, minClient) < 0;
}
